<mat-card class="mt-4">
    <mat-card-header class="mb-3">
        <mat-card-title class="fs-5 fw-bold text-secondary">
            <mat-icon class="align-middle me-2">insights</mat-icon>
            Indicadores gerais
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="row g-3">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let indicador of indicadoresGerais">
                <mat-card class="h-100 card-indicador">
                    <mat-card-content class="text-center p-3">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                            <mat-icon [class]="getCorClasse(indicador.cor)" class="fs-1">{{ indicador.icone }}</mat-icon>
                            <button mat-icon-button 
                                    [matTooltip]="indicador.descricao + ' (' + indicador.periodicidade + ')'" 
                                    matTooltipClass="tooltip-multiline">
                                <mat-icon class="fs-6 text-muted">info</mat-icon>
                            </button>
                        </div>
                        <h3 class="fs-2 fw-bold mb-1">{{ indicador.valor }}</h3>
                        <p class="fs-6 text-muted mb-0">{{ indicador.titulo }}</p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </mat-card-content>
</mat-card>
